import Emitter from "./Emitter";

export default class GameJackpotStart extends Emitter{
    constructor(gb) {
        super(gb);
    }

    TECH4BET_handler(){
        this.emitTop( {method: "game.jackpot.started"})
        this.emitParent({method: "game.jackpot.started"})
    }

    _default() {
        this.emitTop({ wpgaction: "game.jackpot.started" });
        this.emitParent({ wpgaction: "game.jackpot.started" });
        this.emitiOS({ wpgaction: "game.jackpot.started" });
    }

}